var Bavaria = "บาวาเรีย";
var Berlin = "เบอร์ลิน";
var Brandenburg = "บรันเดินบวร์ค";
var Bremen = "เบรเมิน";
var Hamburg = "ฮัมบวร์ค";
var Hesse = "เฮ็สเซิน";
var Saarland = "ซาร์แลนด์";
var Saxony = "แซกโซนี";
var Thuringia = "ทือริงเงิน";
var DEStates = {
	"Baden-Wuerttemberg": "บาเดิน-เวือร์ทเทิมแบร์ค",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "เมคเลินบวร์ค-ฟอร์พ็อมเมิร์น",
	"Lower Saxony": "โลเวอร์แซกโซนี",
	"North Rhine-Westphalia": "นอร์ทไรน์-เว็สท์ฟาเลิน",
	"Rhineland-Palatinate": "ไรน์แลนด์-พาลาทิเนต",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "แซกโซนี-แอนฮัลต์",
	"Schleswig-Holstein": "ชเลสวิช-ฮ็อลชไตน์",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
